'use strict';
import Megatron from '@stencil/megatron';
import prepareGetUserReviewsUrls from '@stencil/hotels-utils/src/get-user-reviews-url';

export async function getUserReviews(
  hotelId,
  offset,
  limit,
  tagIds,
  filter,
  sortBy,
  searchText,
  reviewId,
) {
  const url = prepareGetUserReviewsUrls(
    hotelId,
    offset,
    limit,
    tagIds,
    filter,
    sortBy,
    searchText,
    reviewId,
  );
  const response = await Megatron({
    name: 'Fetch User Reviews',
    type: 'GET',
    url,
  });
  return response;
}

export default getUserReviews;
